export default __webpack_public_path__ + "media/design-system/avatar/assets/default_consumer-d1e43d790dce4ce16ae524d4e1fd6520.svg";